<template>
  <router-view v-if="hiddenAsideMenu"></router-view>
  <AsideLayout v-else class="aside-menu-layout">
    <template #aside>
      <div class="menu-container">
        <div class="aside-menu">
          <div
            v-for="(item, index) in menuList"
            class="menu-item"
            :class="activeMenuIndex === index && 'is-active'"
            :key="index">
            <span class="link" @click="handleClick(item, index)">{{ item.meta.menu.label }}</span>
          </div>
        </div>
      </div>
    </template>
  </AsideLayout>
</template>

<script>
import _ from 'lodash'
import AsideLayout from './asideLayout'

export default {
  components: {
    AsideLayout
  },
  data () {
    return {
      menuList: [],
      activeMenuIndex: ''
    }
  },
  computed: {
    hiddenAsideMenu () {
      return this.$route?.meta?.hiddenAsideMenuLayout
    }
  },
  created () {
    this.loadMenu()
  },
  methods: {
    loadMenu () {
      const parent = this.$parent
      const layoutRoute = parent.tabList[parent.activeTabIndex]
      const metaInfoList = [this.$route.meta]
      let metaInfo = metaInfoList[0]
      while ((metaInfo = metaInfo._parent?.meta)) {
        metaInfoList.push(metaInfo)
      }
      if (layoutRoute && layoutRoute.children) {
        let menuIndex = 0
        this.menuList = _.filter(layoutRoute.children, (item) => {
          const hasPermission = this.hasAnyPermission(item.meta.permission)
          if (metaInfoList.includes(item.meta)) {
            if (hasPermission) {
              this.activeMenuIndex = menuIndex
            } else {
              this.$router.replace('/error/no-permission')
              return false
            }
          }
          if (hasPermission) {
            menuIndex++
          }
          return hasPermission
        })
      }
    },
    handleClick (menuItem, index) {
      if (menuItem.meta.isInclude) {
        if (this.$route.path === menuItem.path && this.activeMenuIndex === index) {
          this.reloadPage()
        } else {
          this.$router.push(menuItem.path, () => {
            this.activeMenuIndex = index
          })
        }
      } else {
        window.location.href = menuItem.path
      }
    }
  },
  watch: {
    $route () {
      this.loadMenu()
      const metaInfoList = [this.$route.meta]
      let metaInfo = metaInfoList[0]
      while ((metaInfo = metaInfo._parent?.meta)) {
        metaInfoList.push(metaInfo)
      }
      this.activeMenuIndex = _.findIndex(this.menuList, (item) => metaInfoList.includes(item.meta))
    }
  }
}
</script>

<style lang="scss" scoped>
.aside-menu-layout {
  .menu-container {
    padding: 62px 0 80px;

    .menu-item {
      height: 42px;
      line-height: 42px;
      padding-left: 20px;
      font-size: 14px;
      overflow: hidden;
      word-break: keep-all;
      white-space: nowrap;
      text-overflow: ellipsis;

      &.is-active {
        background: url($baseDomain + 'static/images_en/leftNav_over.png') no-repeat;

        span {
          color: #232323;
          cursor: default;

          &:hover {
            color: #232323;
          }
        }
      }
    }
  }
}
</style>
